export const DeviceStatus = {
  CONNECTED: "is_connected",
  DISCONNECTED: "disconnected",
  DEVICE_NOT_FOUND: "device_not_found",
} as const;

export type DeviceStatus = typeof DeviceStatus[keyof typeof DeviceStatus];

/** Customers list API filter (`connectionStatus`). Only sent when the toggle is on. */
export const ConnectionStatus = {
  DISCONNECTED: 'disconnected',
} as const;

export type ConnectionStatus =
  typeof ConnectionStatus[keyof typeof ConnectionStatus];

export const MeterStatus = {
  NOT_CONNECTED: "NOT CONNECTED",
  KEY_REQUIRED: "KEY REQUIRED",
  ENCRYPTION_KEY: "ENCRYPTION KEY",
  NO_DATA: "NO DATA",
  NOT_RECOGNIZED: "NOT RECOGNIZED",
  RECOGNITION: "RECOGNITION",
  UNKNOWN: "unknown",
  OK: "OK",
} as const;

export type MeterStatus = typeof MeterStatus[keyof typeof MeterStatus];